<template>
    <!--Categories column -->
    <v-flex shrink class="catalog-list" style="border: none">
        <ul>
            <li style="display: flex; justify-content: space-between; white-space: normal !important; word-wrap: break-word;"
                class="pa-2" v-for="category in categories" :key="category.id"
                :class="{ 'active': isActiveCategory(selectedCategories, category.id) }" @click="selectCategory(category)"
                >
                {{ category.name }}
                <v-icon right>chevron_right</v-icon>
            </li>
        </ul>
    </v-flex>
</template>
<script>
export default {
    name: "CategoryDesktop",
    props: {
        categories: {
            type: Array,
            required: true
        },
        selectedCategories: {
            type: Array
        },
    },
    methods: {
      selectCategory(category){
        this.$emit("Update", category)
      },
    //   previewCategory(category) {
    //     this.$emit("PreviewFn", category)
    //   },
      isActiveCategory(list, id) {
      return list.findIndex(item => item.id === id) !== -1;
    },
    }
}
</script>